<template>
  <div class="auditor-container">
    <router-view></router-view>
  </div>
</template>
<script>
// Import Bootstrap CSS and JavaScript here
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
export default {
  mounted() { },
  props: [],
  async created() {
    localStorage.removeItem("parentUrlUser");
    localStorage.removeItem("publicUrlUser");
    localStorage.removeItem("token");
    localStorage.removeItem("auditorAuthToken");
    localStorage.removeItem("userPermissions");

    var parentAuthToken = localStorage.getItem("parentAuthToken");
    if (parentAuthToken) {
      this.$router.push('/parentuser/dashboard');
    } else {
      const email = this.$route.params.email ?? null;
      this.$router.push(`/parentuser/login/${email}`);
    }
  },
  components: {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
/* .auditor-container{
background-color: #0da2a2;
} */
</style>
